import { API } from '../../../../common/api/constants';

export const GET_ORDER_BY_ID = `${API}/document/order/{order_id}/profile/{profile_id}`;
